import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BlNgUiComponentModule } from '@blcloud/bl-ng-ui-component';
import {
  ApproachSettingDetailsModule,
  TicketIssueGuideModule,
  ServiceModule,
  MessagePreviewModalModule,
  LabelModule,
  AttachmentModule,
  LineMsgTemplateGuideModule
} from '@blcloud/bl-ng-share-module';
import {
  DmContentInfoResource,
  DmIssueSettingResource,
  DmApproachInfoResource,
  DmIssueInfoResource,
  DmApproachInfoBulkUpdateResource,
  SnsShopAccountSettingResource,
  LineMsgTemplateResource,
  SnsPublicTemplateResourceResource
} from '@blcloud/bl-ng-resource';

import { SnsSendMessageModalComponent } from './sns-send-message-modal.component';
import { SnsSendMessageModalService } from './sns-send-message-modal.service';
import { SnsSendMessageConditionPanelModule } from './condition-panel';
import { SnsSendMessageContentComponent } from './content/sns-send-message-content.component';

@NgModule({
  imports: [
    CommonModule,
    BlNgUiComponentModule,
    SnsSendMessageConditionPanelModule,
    ApproachSettingDetailsModule.forRoot(),
    MessagePreviewModalModule,
    TicketIssueGuideModule,
    ServiceModule,
    LabelModule.forRoot(),
    AttachmentModule,
    LineMsgTemplateGuideModule
  ],
  exports: [
    SnsSendMessageModalComponent,
    SnsSendMessageContentComponent,
  ],
  declarations: [
    SnsSendMessageModalComponent,
    SnsSendMessageContentComponent,
  ],
  providers: [
    DmContentInfoResource,
    DmIssueSettingResource,
    DmApproachInfoResource,
    DmIssueInfoResource,
    DmApproachInfoBulkUpdateResource,
    SnsShopAccountSettingResource,
    LineMsgTemplateResource,
    SnsPublicTemplateResourceResource,
  ],
  entryComponents: [
    SnsSendMessageModalComponent,
    SnsSendMessageContentComponent,
  ]
})
export class SnsSendMessageModalModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SnsSendMessageModalModule,
      providers: [
        DmContentInfoResource,
        DmIssueSettingResource,
        DmApproachInfoResource,
        DmIssueInfoResource,
        DmApproachInfoBulkUpdateResource,
        SnsShopAccountSettingResource,
        SnsSendMessageModalService,
        LineMsgTemplateResource,
        SnsPublicTemplateResourceResource,
        AttachmentModule.forRoot().providers,
        LineMsgTemplateGuideModule.forRoot().providers
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/sns-send-message-modal/sns-send-message-modal.module.ts